export default {
    methods: {
        isValid(value, type) {
            const regexes = {
                coordinates: /^-?\d+(\.\d*)?$/,
                email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
                website: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/
            };
            
            if (type === 'email' && value) {
                let separator = value.includes(",") ? "," : value.includes(";") ? ";" : null;
            
                if (separator) {
                    return value.split(separator).every(email => regexes.email.test(email.trim()));
                }

                return regexes.email.test(value.trim());
            }

            return regexes[type] ? regexes[type].test(value) : false;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/validationHelpers.js